import { Box, Card, Typography } from '@material-ui/core';
import styled from 'styled-components';

export const CustomCard = styled(Card)`
  padding: 20px;
  border: 1px solid;
  border-color: #ddd;
  box-shadow: none;
`;

export const Title = styled(Typography)`
  font-weight: bold;
  font-size: 15px;
  color: #616161;
  padding-bottom: 8px;
`;

export const Subtitle = styled(Typography)`
  font-size: 12px;
  color: #616161;
  padding: 4px 0 12px 0;
`;

export const ChildrenContainer = styled(Box)`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'row'};
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: ${(props) => props.alignItems || 'center'};
  flex-wrap: ${(props) => props.flexWrap || 'nowrap'};
  width: 100%;
`;
